import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import { Tooltip } from '@material-ui/core';

class AccessibleTooltip extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  onOpen = () => {
    this.setState({ open: true });
  };

  onClose = () => {
    this.setState({ open: false });
  };

  onKeyDown = (ev) => {
    if ((this.props.allowEscapeKey && ev.key === "Escape") || ev.key === "ArrowRight") {
      ev.preventDefault();
      ev.stopPropagation();
      if (this.state.open) {
        this.onClose();
      }
    }
  };

  componentDidUpdate() {
    if (this.state.open) {
      document.addEventListener('keyup', this.onKeyDown);
    }
    else {
      document.removeEventListener('keyup', this.onKeyDown);
    }
  }

  render() {

    const { placement, title, children } = this.props;
    const { open } = this.state;

    return (
      <Tooltip
        id="accessible-tooltip"
        placement={placement}
        title={title}
        open={open}
        onOpen={this.onOpen}
        onClose={this.onClose}
        PopperProps={{
          role: "tooltip",
          "data-test": "tooltip",
          onClick: ev => {
            ev.preventDefault();
            ev.stopPropagation();
          }
        }}
        interactive={true}>
        {children}
      </Tooltip>
    );
  }
}

AccessibleTooltip.defaultProps = {
  placement: "left",
  allowEscapeKey: false
};

AccessibleTooltip.propTypes = {
  title: PropTypes.any,
  allowEscapeKey: PropTypes.bool,
  children: PropTypes.any,
  placement: PropTypes.oneOf(["left", "right", "right-end", "bottom"])
};

export default withStyles(styles)(AccessibleTooltip);